<template>
  <div class="notifications">
    <h1 class="notifications__title page-title">
      Notifications
    </h1>

    <div class="card">
      <div class="notifications__list">
        <div
          v-for="(notification, index) in notificationArray"
          :key="notification.userNotificationId"
        >
          <notification-preview
            :notification-data="notification"
            @update-data="handleUpdateData"
          />
          <el-divider v-if="index < notificationArray.length - 1" />
        </div>
      </div>

      <div
        class="notifications__empty-text"
        v-if="notificationArray.length === 0"
      >
        No notifications
      </div>
    </div>
  </div>
</template>

<script>
import { UPDATE_USER_NOTIFICATIONS } from '@/store/mutationTypes.js';
import NotificationPreview from '@/components/notifications/NotificationPreview.vue';

export default {
  name: 'Notifications',
  components: {
    NotificationPreview,
  },
  computed: {
    notificationArray() {
      return this.$store.state.notifications.notificationArray;
    },
  },
  methods: {
    handleUpdateData() {
      this.$store.dispatch(UPDATE_USER_NOTIFICATIONS);
    },
  },
  created() {
    this.$store.dispatch(UPDATE_USER_NOTIFICATIONS);
  },
};
</script>

<style lang="scss">
.notifications {
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-250);
    font-weight: 500;
    font-size: var(--font-size-800);
  }
  &__list {
  }
}
</style>
